//====================================================
//  Initialization Select
//====================================================
function fn_components_select(){
	if ($('.js-select').length){
		$('.js-select').each(function(){
			var inst = $(this);
			var thisClass = inst.data('class');
			
			inst.select2({
				minimumResultsForSearch: Infinity,
				placeholder: function(){
					$(this).data('placeholder');
				}
			}).focus(function () { $(this).select2('open'); });

			inst.on('select2:select', function (e) {
			    var data = e.params.data;
			    if (!$('.modal-block').hasClass('active')){
					var selectModal = $('.modal-block').find('.js-select[data-class=' + thisClass + ']');
					selectModal.val(data.id).trigger("change");
				} else {
					var selectModal = $('.js-main-offer-form').find('.js-select[data-class=' + thisClass + ']');
					selectModal.val(data.id).trigger("change");
				}
			});
		});
	}
}